.Subtitles {
    color: #74b5aa;
    text-shadow:
        -1px -1px 0 #000,
        1px -1px 0 #000,
        -1px 1px 0 #000,
        1px 1px 0 #000,
        0 0 4px #74b5aa,
        0 0 12px #74b5aa;
    background-color: rgba(0, 0, 0, 0.65);

    position: absolute;
    bottom: 200px;
    left: 580px;
    width: 1400px;
    font-size: 50px;
    text-align: center;

    font-family: "VT323", monospace;
    font-weight: 400;
    font-style: normal;

    text-transform: uppercase;
    z-index: 1000;
}
